import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useLocation} from "react-router-dom";
import {DeleteModal, FullTable} from "components";
import {emptyStateRates, payerRatesBody, payerRatesHeader} from "../constants";
import {payerActions} from "store";
import {AddRate} from "./addRate";
import {usePrimaryModal} from "utils";

const ACTION_TYPE = "GET_PAYER_RATES";
const ACTION_DELETE = "DELETE_PAYER_RATE";

export const Rates = ({payerId}) => {
    const payersRatesList = useSelector((state) => state.payers?.payersRatesList);
    const dispatch = useDispatch();
    const location = useLocation();
    const {openPrimary, closePrimary} = usePrimaryModal();
    const info = location.state;

    useEffect(() => {
        const params = {
            payer: payerId,
            types: info?.types,
        };
        dispatch(payerActions.getPayerRates(params));
    }, [payerId, info?.types?.length]);

    const addPayerRate = (item) => {
        openPrimary(<AddRate item={item} payerId={payerId}/>, {
            noShowCloseBtn: true,
            padding: "noPaddings",
            maxWidth: 482
        });
    };

    const handleDelete = (item) => {
        openPrimary(
            <DeleteModal
                handleDelete={() => {
                    dispatch(payerActions.deletePayerRate(item?.id));
                }}
                handleCancel={closePrimary}
                actionType={ACTION_DELETE}
                description={"This action is irreversible, and once deleted."}
                title={`Are you sure you want to remove Rate?`}
                afterSuccess={() => {
                    const params = {
                        ...info,
                        payer: payerId,
                    };
                    dispatch(payerActions.getPayerRates(params, true));
                    closePrimary();
                }}
            />,
            {
                noShowCloseBtn: true,
                padding: "noPaddings",
                maxWidth: 407
            },
        );
    };

    return (
        <div className="payer-rates-wrapper">
            <FullTable
                head={payerRatesHeader()}
                body={payerRatesBody({
                    handleDelete,
                    handleEit: (item) => addPayerRate(item),
                })}
                list={payersRatesList?.rates || []}
                loadingType={ACTION_TYPE}
                containerStyles={{height: "41vh"}}
                emptyState={emptyStateRates()}
            />
        </div>
    );
};
